<template>
  <div class="commodityBody">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="cardheader">
             <el-select
          size="mini"
          v-model="commodityType"
          @change="commodityTypeChange"
        
          placeholder="请选择"
        >
          <el-option
            v-for="item in commodityTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <!-- <el-button  type="text">添加商品</el-button> -->
        </div>
       
      </div>
      <div>
        <el-table :data="tableData" style="width: 100%" height="600">
          <el-table-column prop="order_id" label="订单编号" width="200"></el-table-column>
          <el-table-column prop="order_user_name" label="收件人名称">
          
          </el-table-column>
          <el-table-column prop="order_user_address" label="收件地址"></el-table-column>
          <el-table-column prop="order_user_phone" label="收件人电话"></el-table-column>
          <el-table-column prop="order_merchant_state" label="订单状态">
              <template slot-scope="scope">
                <el-tag :type="getorderType(scope.row.order_merchant_state)">{{getorderType2(scope.row.order_merchant_state)}}</el-tag>
              </template>
          </el-table-column>
          <el-table-column prop="order_commodity_total" label="商品总价"></el-table-column>
          <el-table-column prop="order_commodity_total" label="商品信息">
            <template slot-scope="scope">
             <div class="conniditList">
                <div class="conniditListItem" v-for="item in scope.row.order_commodity_list">
                    <div>
                        <img style="width:30px;height:30px" :src="item.commodity_pic" alt="">
                    </div>
                    <div style="margin-left:15px">
                         {{item.commodity_name}}*{{item.commodity_count}}
                    </div>
                   
                </div>
             </div>
            </template>
          </el-table-column>
             <el-table-column prop="order_commodity_total" label="操作">
                <template slot-scope="scope">
        <el-button  type="text" size="small" @click="sendOver(scope.row.order_id)">确认送达</el-button>
       
      </template>
             </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      commodityType: "全部",
      commodityTypeList: [
        {
          value: "全部",
          label: "全部"
        },
        {
          value: "已发货",
          label: "已发货"
        },
         {
          value: "未发货",
          label: "未发货"
        },
         {
          value: "已完成",
          label: "已完成"
        },
      ],
      // commodityList: []
      orderList:[],
      userId:""
    };
  },
  mounted() {
       this.userId = this.$store.state.userData
    this.getTaleData();
  },
  methods: {
    sendOver(code){
        this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `https://www.moodsci.com/mall/pay/orderService/confirmSend?orderNum=${code}`
      }).then((res)=>{
        // console.log(res);
        this.getTaleData()
      })
    },
    getorderType(data){
        if(data==1){
           return 'warning'
        }else if(data==2){
            return 'success'
        }if(data==3){
            return 'info'
        }
    },
       getorderType2(data){
        if(data==1){
            return '未发货'
        }else if(data==2){
            return "已发货"
        }else if(data==3){
            return "已完成"
        }
    },
    commodityTypeChange(data){
        
      // console.log(data);
      if(data =='全部'){
          this.tableData=  this.orderList
      }else if(data == '已发货'){
          this.tableData=  this.orderList.filter((el)=>{
            return el.order_merchant_state ==2
        })
      }else if(data == '未发货'){
          this.tableData=  this.orderList.filter((el)=>{
            return el.order_merchant_state ==1
        })
      }else if(data == '已完成'){
        this.tableData=  this.orderList.filter((el)=>{
            return el.order_merchant_state ==3
        })
      }
    },
    getTaleData() {
      this.$axios({
        method: "get",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `https://www.moodsci.com/pigbox/OrderService//queryMerchantAllOrder/${this.userId}`
      }).then(res => {
        this.tableData = res.data
        console.log(res.data);
        this.orderList = res.data

      });
    }
  }
};
</script>

<style>
.commodityBody {
  height: 100%;
  width: 100%;
}
.box-card {
  height: 100%;
}
.cardheader{
    width: 100%;
    display: flex;
    justify-content: space-between;
}
.conniditListItem{
    height: 30px;
    display: flex;
    align-items: center;
    
}
/* 。editMainBox */
</style>